import React, { useContext } from "react";
import { Form, DropdownItemProps, Grid } from "semantic-ui-react";
import Button from "../../../elements/Button";
import CaseType from "../../../../models/CaseType";
import Result from "../../../../common/repository/Result";
import { toast } from "../../../common/Toast";
import CaseCategoryRepository from "../../../../common/repository/CaseCategoryRepository";
import validator from "../../../../common/validator";
import { TagsInput } from "react-tag-input-component";
import ClientPageContext from "./ClientPageContext";
import ClientRepository from "../../../../common/repository/ClientRepository";
import Client from "../../../../models/Client";

interface Props {
  caseType?: CaseType;
  onSuccess: (client: Client) => void;
  onError?: () => void;
}

const ClientCaseTypeForm: React.FC<Props> = ({ caseType, onSuccess, onError }) => {
  const context = useContext(ClientPageContext);
  const caseCategoryRepo = new CaseCategoryRepository();
  const clientRepo = new ClientRepository();

  const [form_loading, setForm_loading] = React.useState(false);
  const [form_caseCategoryOptions, setForm_caseCategoryOptions] = React.useState<DropdownItemProps[]>([]);
  const [form_caseCategoryLoading, setForm_caseCategoryLoading] = React.useState(false);
  const [caseType_title, setCaseType_title] = React.useState("");
  const [caseType_category, setCaseType_category] = React.useState("");
  const [caseType_internalTATDays, setCaseType_internalTATDays] = React.useState("");
  const [caseType_internalTATHours, setCaseType_internalTATHours] = React.useState("");
  const [caseType_investigatorTATDays, setCaseType_investigatorTATDays] = React.useState("");
  const [caseType_investigatorTATHours, setCaseType_investigatorTATHours] = React.useState("");
  const [caseType_initialCasePortionCapping, setCaseType_initialCasePortionCapping] = React.useState("");
  const [caseType_Services, setCaseType_Services] = React.useState<string[]>([]);
  const [CaseType_RequiredDocumnets, setCaseType_RequiredDocumnets] = React.useState<string[]>([]);

  const servicesType = [
    "INSURED STATEMENT - INSURED INFORMATION",
    "WORK PLACE VISIT - INSURED OCCUPATION INFORMATION",
    "ATTENDANT ID - ATTENDANT INFORMATION",
    "ICP - HOSPITAL INFRASTRUCTURE INFORMATION",
    "DOCTOR STATEMENT - TREATING DOCTOR INFORMATION",
    "PATHOLOGIST STATEMENT - PATHOLOGIST INFORMATION",
  ];

  React.useEffect(() => {
    getCaseCategories();
  }, []);

  // Populate form fields when caseType prop is provided (edit mode)
  React.useEffect(() => {
    if (caseType) {
      setCaseType_title(caseType.getTitle());
      setCaseType_category(caseType.getCaseCategoryCode());
      
      const [internalDays, internalHours] = CaseType.getTATPair(caseType.getInternalTAT());
      setCaseType_internalTATDays(internalDays.toString());
      setCaseType_internalTATHours(internalHours.toString());
      
      const [investigatorDays, investigatorHours] = CaseType.getTATPair(caseType.getInvestigatorTAT());
      setCaseType_investigatorTATDays(investigatorDays.toString());
      setCaseType_investigatorTATHours(investigatorHours.toString());
      
      setCaseType_initialCasePortionCapping(caseType.getInitialCasePortionCapping().toString());
      const services = caseType.getServices();
      console.log(services,"kalyani")
      const serviceMapping: Record<string, string> = {
          "HOSPITAL INFRASTRUCTURE": "HOSPITAL INFRASTRUCTURE INFORMATION",
          "TREATING DOCTOR": "TREATING DOCTOR INFORMATION",
          "PATHOLOGIST": "PATHOLOGIST INFORMATION",
          "INSURED INFO": "INSURED INFORMATION",
          "ATTENDANT INFO": "ATTENDANT INFORMATION",
          "HOSPITAL INFRASTRUCTURE INFORMATION": "HOSPITAL INFRASTRUCTURE INFORMATION"
          
      };

        const validNewServices = [
          "HOSPITAL INFRASTRUCTURE INFORMATION",
          "TREATING DOCTOR INFORMATION",
          "PATHOLOGIST INFORMATION",
          "INSURED INFORMATION",
          "ATTENDANT INFORMATION",
        ];

        const mappedServices = services.filter((service: string) => {
          return serviceMapping[service] || validNewServices.includes(service);
        }).map((service: string) => {
          return serviceMapping[service] || service;
        });

        setCaseType_Services(mappedServices);
      // Handle services - check if old format or new format
      // const oldServices = ["HOSPITAL INFRASTRUCTURE", "TREATING DOCTOR", "PATHOLOGIST", "INSURED INFO", "ATTENDANT INFO"];
      // const services = caseType.getServices();

      // const isOldFormat = services.some((service: string) => oldServices.includes(service));
      // setCaseType_Services(isOldFormat ? [] : services);
      
      setCaseType_RequiredDocumnets(caseType.getRequiredDocumne() || []);
    }
  }, [caseType]);

  const getCaseCategories = async () => {
    setForm_caseCategoryLoading(true);
    const result = await caseCategoryRepo.getCategories({isDeleted: false});
    if (result instanceof Result.Success) {
      const options = result.data.items.map((it) => {
        return {
          text: it.getTitle(),
          value: it.getCode(),
          key: it.getCode(),
        };
      });
      setForm_caseCategoryOptions(options);
      setForm_caseCategoryLoading(false);
    } else {
      setForm_caseCategoryLoading(false);
      toast.error("Could not load case categories");
    }
  };

  const onSubmit = () => {
    setForm_loading(true);
    if (caseType) {
      updateCaseType();
    } else {
      addCaseType();
    }
  };

  const addCaseType = async () => {
    if (!context.client) {
      toast.error("Client not found");
      setForm_loading(false);
      if (onError) onError();
      return;
    }

    // Convert days to hours (1 day = 9 hours based on CaseType model)
    const internalTAT =
      CaseType.toHours(parseInt(caseType_internalTATDays)) +
      parseInt(caseType_internalTATHours);
    const investigatorTAT =
      CaseType.toHours(parseInt(caseType_investigatorTATDays)) +
      parseInt(caseType_investigatorTATHours);
    let capping = parseFloat(caseType_initialCasePortionCapping);

    const result = await clientRepo.addCaseType({
      clientId: context.client.getId(),
      caseTypes: {
        name: caseType_title,
        internalTAT: internalTAT.toString(),
        investigatorTAT: investigatorTAT.toString(),
        capping: capping.toString(),
        caseCategory: caseType_category,
        services: caseType_Services,
        requiredDocuments: CaseType_RequiredDocumnets
      }
    });

    if (result instanceof Result.Success) {
      const client = result.data;
      setForm_loading(false);
      toast.success("Case Type added successfully");
      onSuccess(client);
    } else {
      setForm_loading(false);
      const message = result.message || "Something went wrong";
      toast.error(message);
      if (onError) onError();
    }
  };

  const updateCaseType = async () => {
    if (!context.client || !caseType) {
      toast.error("Client or Case Type not found");
      setForm_loading(false);
      if (onError) onError();
      return;
    }

    // Convert days to hours (1 day = 9 hours based on CaseType model)
    const internalTAT =
      CaseType.toHours(parseInt(caseType_internalTATDays)) +
      parseInt(caseType_internalTATHours);
    const investigatorTAT =
      CaseType.toHours(parseInt(caseType_investigatorTATDays)) +
      parseInt(caseType_investigatorTATHours);
    let capping = parseFloat(caseType_initialCasePortionCapping);

    const result = await clientRepo.updateCaseType({
      clientId: context.client.getId(),
      caseTypeId: caseType.getId(),
      caseTypes: {
        name: caseType_title,
        internalTAT: internalTAT.toString(),
        investigatorTAT: investigatorTAT.toString(),
        capping: capping.toString(),
        caseCategory: caseType_category,
        services: caseType_Services,
        requiredDocuments: CaseType_RequiredDocumnets
      }
    });

    if (result instanceof Result.Success) {
      const client = result.data;
      setForm_loading(false);
      toast.success("Case Type updated successfully");
      onSuccess(client);
    } else {
      setForm_loading(false);
      const message = result.message || "Something went wrong";
      toast.error(message);
      if (onError) onError();
    }
  };

  const handleCheckboxChange = (event: any) => {
    let newArray = [...caseType_Services, event.target.id];
    if (caseType_Services.includes(event.target.id)) {
      newArray = newArray.filter(day => day !== event.target.id);
    }
    
    let documentWithService: string[] = newArray.map((service: string) => {
      return servicesType.find(item => item.includes(service)) || "";
    });
    
    let documentArray: string[] = documentWithService.map((document) => {
      return document.split("-")[0].trim();
    });
    
    documentArray.map((singleDocument) => {
      if(CaseType_RequiredDocumnets.includes(singleDocument))  {
        documentArray = documentArray.filter(docment =>  docment !== singleDocument)
      }
    });
    
    let documentNewArray: string[] = [...CaseType_RequiredDocumnets, ...documentArray];

    setCaseType_RequiredDocumnets(documentNewArray);
    setCaseType_Services(newArray);
  };

  return (
    <Form loading={form_loading}>
      {/* name */}
      <Form.Input
        label="Case Type Name"
        placeholder="e.g. Cashless"
        value={caseType_title}
        onChange={(_, { value }) => setCaseType_title(value)}
      />
      {/* name */}

      {/* case category */}
      <Form.Dropdown
        selection
        loading={form_caseCategoryLoading}
        label="Case Category"
        placeholder="Select a category"
        options={form_caseCategoryOptions}
        value={caseType_category}
        onChange={(_, { value }) =>
          setCaseType_category(value as string)
        }
      />
      {/* case category */}

      {/* internal TAT */}
      <Form.Group>
        <Form.Input
          label="Client TAT (Days)"
          placeholder="Enter days"
          value={caseType_internalTATDays}
          onChange={(_, { value }) => {
            if (validator.integer.isValid(value))
              setCaseType_internalTATDays(value);
          }}
        />
        <Form.Input
          label="Client TAT (Hours)"
          placeholder="Enter hours"
          value={caseType_internalTATHours}
          onChange={(_, { value }) => {
            if (validator.integer.isValid(value))
              setCaseType_internalTATHours(value);
          }}
        />
      </Form.Group>
      {/* internal TAT */}

      {/* investigator TAT */}
      <Form.Group>
        <Form.Input
          label="Internal TAT (Days)"
          placeholder="Enter days"
          value={caseType_investigatorTATDays}
          onChange={(_, { value }) => {
            if (validator.integer.isValid(value))
              setCaseType_investigatorTATDays(value);
          }}
        />
        <Form.Input
          label="Internal TAT (Hours)"
          placeholder="Enter hours"
          value={caseType_investigatorTATHours}
          onChange={(_, { value }) => {
            if (validator.integer.isValid(value))
              setCaseType_investigatorTATHours(value);
          }}
        />
      </Form.Group>
      {/* investigator TAT */}

      {/* case portion capping */}
      <Form.Input
        label="Initial Case Portion Capping"
        placeholder="Value between 0.00 and 5.00"
        value={caseType_initialCasePortionCapping}
        onChange={(_, { value }) => {
          const numValue = parseFloat(value);
          if (value.length === 0 || (numValue >= 0 && numValue <= 5))
            setCaseType_initialCasePortionCapping(value);
        }}
      />
      <label><strong> Mandatory Documents</strong></label>
      <Grid>
          <Grid.Row style={{ paddingTop: "20px" }}>
            {servicesType.map((item, index) => {
              const [_, rightSide] = item.split(" - ");
              return (
                <Grid.Column width={16} key={index}>
                  <input
                    className="CaseTypeCheck"
                    type="checkbox"
                    id={rightSide} 
                    value={rightSide} 
                    onChange={handleCheckboxChange}
                    checked={caseType_Services.includes(rightSide)} 
                  />
                  <label htmlFor={rightSide}>{item}</label> 
                </Grid.Column>
              );
            })}
          </Grid.Row>
      </Grid>
      <label>Other Required Documents</label>
      <TagsInput
        value={CaseType_RequiredDocumnets}
        onChange={(value: any) => setCaseType_RequiredDocumnets(value)}
        name="Required Documents"
        placeHolder="PanCard"
      />
      {/* case portion capping */}
      <Button
      style={{marginTop:"10px"}}
        positive
        onClick={onSubmit}
        disabled={
          caseType_title.trim().length === 0 ||
          caseType_category.trim().length === 0 ||
          caseType_internalTATDays.trim().length === 0 ||
          caseType_internalTATHours.trim().length === 0 ||
          caseType_investigatorTATDays.trim().length === 0 ||
          caseType_investigatorTATHours.trim().length === 0 ||
          caseType_initialCasePortionCapping.trim().length === 0 ||
          CaseType_RequiredDocumnets.length === 0
        }
      >
        {caseType ? "Update" : "Submit"}
      </Button>
    </Form>
  );
};

export default ClientCaseTypeForm;
